'use client';

import { useTheme } from 'next-themes';
import type React from 'react';
import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

export interface ToastProviderProps extends ToasterProps {
  children?: React.ReactNode;
}

export function ToastProvider({ children, ...props }: ToastProviderProps) {
  const { theme = 'system' } = useTheme();

  return (
    <>
      {children}
      <SonnerToaster
        theme={theme as ToasterProps['theme']}
        className="toaster group"
        position="top-right"
        richColors
        closeButton
        duration={4000}
        style={
          {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
          } as React.CSSProperties
        }
        {...props}
      />
    </>
  );
}
